import { SEARCH_MESSAGES } from "./constants";

export function searchChiiki(context, form, loadError = "") {
  if (loadError) {
    return { status: "error", message: loadError };
  }
  if (!context) {
    return { status: "error", message: SEARCH_MESSAGES.csvNotReady };
  }
  if (!form.addr.trim()) {
    return { status: "message", message: SEARCH_MESSAGES.addrRequired };
  }

  const { law, date, addr, keikasochi } = form;
  const chiiki = context.getChiikiByAddr({ law, date, addr, keikasochi });
  if (!chiiki) {
    return { status: "notFound" };
  }

  const code = context.getChiikiCode({ law, date, chiiki, keikasochi });
  return {
    status: "success",
    chiiki,
    code: code || null,
  };
}
